export const quickFiltersNamespace = 'quickFilter';
export const QUICK_FILTER_MAP_DELIMITER = '/';
export const QUICK_FILTER_LIMIT = 5;
export const getQuickFilterUniqueKey = ({
  dataSource,
  name
}) => `${dataSource}${QUICK_FILTER_MAP_DELIMITER}${name}`;